import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { twMerge } from 'tailwind-merge';

interface PasswordInputProps {
  label: string;
  id: string;
  error?: string;
  register: ReturnType<any>;
  inputClassName?: string;
  wrapperClassName?: string;
  labelClassName?: string;
}

const PasswordInput: React.FC<PasswordInputProps> = ({
  label,
  id,
  error,
  register,
  inputClassName,
  wrapperClassName,
  labelClassName,
}) => {
  const [show, setShow] = useState(false);

  const toggleVisibility = () => setShow(prev => !prev);

  return (
    <div>
      <label
        htmlFor={id}
        className={twMerge('block mb-2 font-medium', labelClassName)}
      >
        {label}
      </label>
      <div className={twMerge('relative', wrapperClassName)}>
        <input
          id={id}
          type={show ? 'text' : 'password'}
          className={twMerge(
            `w-full py-3 pl-2 border rounded pr-10`,
            error ? 'border-red-500' : 'border-gray-300',
            inputClassName
          )}
          {...register}
          autoComplete='new-password'
        />
        <button
          type='button'
          onClick={toggleVisibility}
          className='absolute inset-y-0 right-0 flex items-center px-3 text-gray-500'
          aria-label='Toggle password visibility'
        >
          {show ? <FaEyeSlash /> : <FaEye />}
        </button>
      </div>
      {error && <p className='text-red-500 text-sm mt-1'>{error}</p>}
    </div>
  );
};

export default PasswordInput;
